module.exports = __webpack_public_path__ + "static/img/item1.48ecfbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/web/item1.png
// module id = hzsk
// module chunks = 1